import { writable } from "svelte/store";
export const brandActiveFilters =  writable([]);
export const brandFacetFilters =  writable([]);
export const activeCategoryBrandPage =  writable('');
export const alreadyFetchedCategoryData =  writable([]);
export const activeCategoryObj =  writable({});
export const selectedPriceFilter =  writable([]);
export const brandPriceFilters =  writable([]);
export const brandSelectedSort =  writable('');
export const brandSelectedUrl =  writable('');
